import React from 'react';

interface InputWrapperProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'outlined' | 'filled';
  hasError?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
}

export const InputWrapper: React.FC<InputWrapperProps> = ({
  size = 'md',
  variant = 'default',
  hasError,
  disabled,
  children
}) => {
  const wrapperClasses = [
    'ui-input__wrapper',
    `ui-input__wrapper--${size}`,
    `ui-input__wrapper--${variant}`,
    hasError && 'ui-input__wrapper--error',
    disabled && 'ui-input__wrapper--disabled'
  ].filter(Boolean).join(' ');

  return (
    <div className={wrapperClasses}>
      {children}
    </div>
  );
};
